<template>
    <div class="flex items-center justify-center">
        <div class="relative text-lg">
            <button
                class="flex items-center justify-center w-full py-6 px-4 gap-2 text-xs border-2 border-gray-300 text-gray-500 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                data-modal-toggle="pastejsonmodal" data-modal-target="pastejsonmodal">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="currentColor"
                    viewBox="0 0 512 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
                    <path
                        d="M160 0c-23.7 0-44.4 12.9-55.4 32L48 32C21.5 32 0 53.5 0 80L0 400c0 26.5 21.5 48 48 48l144 0 0-272c0-44.2 35.8-80 80-80l48 0 0-16c0-26.5-21.5-48-48-48l-56.6 0C204.4 12.9 183.7 0 160 0zM272 128c-26.5 0-48 21.5-48 48l0 272 0 16c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-220.1c0-12.7-5.1-24.9-14.1-33.9l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1L320 128l-48 0zM160 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
                </svg>
                Paste JSON
            </button>

            <div id="pastejsonmodal" tabindex="-1" aria-hidden="true"
                class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-full max-h-full">
                <div class="relative w-full max-w-5xl max-h-[100dvh]">
                    <!-- Modal content -->
                    <div class="relative bg-white rounded-3xl md:rounded-lg shadow">
                        <!-- Modal header -->
                        <div class="flex items-start justify-between p-5 border-b rounded-t">
                            <h3 class="text-xl font-semibold text-gray-900 lg:text-2xl">
                                {{ $t('Paste JSON string') }}
                            </h3>
                            <button id="closeButton" data-modal-hide="pastejsonmodal" type="button"
                                class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center">
                                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd"
                                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                        clip-rule="evenodd"></path>
                                </svg>
                            </button>
                        </div>
                        <!-- Modal body -->
                        <div class="px-6 py-6">
                            <div @click="copyText()"
                                class="flex mb-10 items-center active:scale-90 rounded-md border border-slate-300 py-2 px-4 text-center text-sm transition-all shadow-sm hover:shadow-lg text-slate-600 hover:text-white hover:bg-gray-400 hover:border-gray-400 focus:text-white focus:bg-gray-400 focus:border-slate-800 active:border-slate-800 active:text-white active:bg-slate-800 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none">
                                Click here to get the question that should be asked to the AI assistant</div>
                            <textarea id="pastejsonfield" class="w-full" @paste="onPaste"
                                placeholder="paste here"></textarea>

                            <div v-if="jsonContent">
                                <pre v-if="isJsonString(jsonContent)" class="max-w-full overflow-x-scroll">
Title = {{ JSON.parse(jsonContent).name }}
Description = {{ JSON.parse(jsonContent).description }}
Start = {{ JSON.parse(jsonContent).start }}
End = {{ JSON.parse(jsonContent).end }} 
Price = {{ JSON.parse(jsonContent).price }}
Sold out = {{ JSON.parse(jsonContent).sold_out }}
External URL {{ JSON.parse(jsonContent).external_url }}
                                </pre>
                                <div v-else>NOT JSON</div>
                            </div>
                        </div>
                        <!-- Modal footer -->
                        <div class="flex items-center justify-between p-6 space-x-2 border-t border-gray-200 rounded-b">

                            <button type="button" data-modal-hide="pastejsonmodal" @click="changeTheme()"
                                class="text-gray-500 bg-white duration-300 transition hover:scale-105 hover:shadow-lg focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10">
                                {{ $t('Cancel') }}</button>
                            <button type="button" data-modal-hide="pastejsonmodal" @click="submitPaste()"
                                class="text-white bg-primary duration-300 transition hover:scale-105 hover:shadow-lg focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">
                                {{ $t('Submit paste') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>

import Gravatar from 'vue-gravatar';

export default {
    components: {
        Gravatar,
    },
    data() {
        return {
            isOptionsExpanded: false,
            jsonContent: null,
        };
    },
    methods: {
        copyText() {
            navigator.clipboard.writeText("Give me a .json file with the following fields, give me the exact same text as html content that the website uses as the description/content of the event, price as a number field, start and end as html datetime fields width date and hours and minutes: 'name', 'description', 'start','end','price','sold_out','external_url' from the following website:");
        },
        submitPaste() {
            document.getElementById("name_en_val").value = JSON.parse(this.jsonContent).name;
            document.getElementById("name").value = JSON.stringify({"en": JSON.parse(this.jsonContent).name});

            document.getElementById("description_val").value = JSON.stringify({"en": JSON.parse(this.jsonContent).description});
            document.getElementById("description_en_val").value = JSON.stringify({"en": JSON.parse(this.jsonContent).description});

            document.getElementById("start").value = JSON.parse(this.jsonContent).start;
            document.getElementById("end").value = JSON.parse(this.jsonContent).end;
            document.getElementById("price").value = JSON.parse(this.jsonContent).price;
            document.getElementById("external_url").value = JSON.parse(this.jsonContent).external_url;
        },
        isJsonString(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        },
        onPaste(e) {
            this.jsonContent = e.clipboardData.getData('text');

            document.getElementById("description_en_val").value = JSON.parse(this.jsonContent).description;
            document.getElementById("description").value = JSON.stringify({"en": JSON.parse(this.jsonContent).description});
        }


    }
};
</script>
  